<template>
    <core-about />
</template>

<script>
  export default {
    name: 'About',

    components: {
      CoreAbout: () => import('@/components/core/About'),
    },
  }
</script>